<script lang="ts">
  import ProfileCard from '$lib/components/profiles/ProfileCard.svelte'

  import SvelteSeo from 'svelte-seo'
  import type { PageServerData } from './$types'

  export let data: PageServerData

  $: description = data.description
  $: title = data.title
  $: travelersConnection = data.travelersConnection
</script>

<SvelteSeo
  twitter={{
    description,
    title,
    imageAlt: title ?? '',
    site: '@airheartinc',
    card: 'summary_large_image',
  }}
  openGraph={{
    title,
    description,
  }}
/>

<div class="bg-white col-span-12 px-4 py-12 mx-auto text-center max-w-7xl sm:px-6 lg:px-8 lg:py-24">
  <div class="space-y-8 sm:space-y-12">
    <div class="space-y-5 sm:mx-auto sm:max-w-xl sm:space-y-4 lg:max-w-5xl">
      <h2 class="text-3xl font-extrabold tracking-tight sm:text-4xl">Airheart Explorers</h2>
      <p class="text-xl text-gray-800">
        Knowledgable travelers have shared their tips for traveling during the pandemic. Click
        through to learn more about them and read their tips.
      </p>
    </div>
    <ul
      class="grid grid-cols-2 mx-auto gap-x-4 gap-y-8 sm:grid-cols-4 md:gap-x-6 lg:max-w-5xl lg:gap-x-8 lg:gap-y-12 xl:grid-cols-6"
    >
      {#each travelersConnection.edges as edge (edge.node.id)}
        <ProfileCard traveler={edge.node} />
      {/each}
    </ul>
  </div>
</div>
